import { useTranslation } from 'react-i18next';
import { Box, CreateHeaders, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import WebkuaTable from '../webkua-table/webkua-table';
import { IAutodeskCatalogProduct } from '../autodesk-catalog/autodesk-catalog';

/**
 * Transition and migration discounts (SU1-4, M2M): paths between licence
 * models, kept visible without becoming their own product.
 */
export function AutodeskCatalogVariantsExpand(props: any) {
  const { t } = useTranslation();
  const product: IAutodeskCatalogProduct = props.data;

  const actionText = (orderAction: string) =>
    orderAction === 'Renewal' ? t("autodeskCatalog.renewal") : t("autodeskCatalog.newSale");

  const programs = (product?.specialPrograms || []).map(p => ({
    ...p,
    actionText: actionText(p.orderAction),
    priceText: p.priceAfterDiscounts != null ? `${p.priceAfterDiscounts} ${product.currency}` : ''
  }));

  return (
    <Box className="p-4">
      {programs.length > 0 &&
        <Box>
          <strong>{t("autodeskCatalog.specialPrograms")}</strong>
          <WebkuaTable
            data={programs}
            disableSearch
            pageSize={25}
            headers={CreateHeaders([
              textHeader("actionText", t("autodeskCatalog.orderAction"), HeaderSizeEnum.MEDIUM),
              textHeader("code", t("autodeskCatalog.discountProgram"), HeaderSizeEnum.MEDIUM),
              textHeader("description", t("autodeskCatalog.description"), HeaderSizeEnum.EXTRA_LARGE),
              textHeader("priceText", t("autodeskCatalog.priceAfterDiscounts"), HeaderSizeEnum.LARGE, {
                cellStyle: { justifyContent: 'right' },
                headerClass: "ag-right-aligned-header"
              })
            ])}
          />
        </Box>}

      {programs.length === 0 &&
        <span>{t("autodeskCatalog.noVariants")}</span>}
    </Box>
  );
}

export default AutodeskCatalogVariantsExpand;
